import { combineReducers } from 'redux';

import error from './error';
import ymodal from './ymodal';
import loader from './loader';

export default combineReducers({
    error,
    ymodal,
    loader
});